import React, { Fragment, useState, useEffect } from 'react';
import OverviewStatCard from './OverviewStatCard';
import OverviewCard from './OverviewCard';
import CustomerEditModal from './CustomerEditModal';
//SVGs Imports

import TotalSites from '../../../../../assets/svgComponent/totalSites';
import TotalRepeaters from '../../../../../assets/svgComponent/totalRepeaters';

import TotalAccessPoint from '../../../../../assets/svgComponent/totalAccessPoints';
// import Device from '../../../../../assets/images/dashboard/device.svg';
//
import Device from './Device';
import Door from './Door';
import Devices from './Devices';
import styles from './style.module.scss';
import ModalAlert from '../../../../../components/Modals/ModalAlert';
//redux
import { useSelector, useDispatch } from 'react-redux';
import {
  doDeleteOrganisation,
  doPartnerHandover,
  doUpdateOrganisation,
} from '../../../../../redux/thunks/organisation';
import { selectCurrentPartner } from '../../../../../redux/selectors/authentication';
//
import { useParams, useHistory } from 'react-router-dom';

import { axiosInfraInstance } from '../../../../../services/api';
import { selectOrganisation } from '../../../../../redux/selectors/organisation';
import HandOverPopup from './HandoverPopUp/HandOverPopup';
import NewAdminPopup from './HandoverPopUp/NewAdminPopup';
import FlexRow from '../../../../../components/FlexBox/FlexRow';
import FlexColumn from '../../../../../components/FlexBox/FlexColumn';
import SDialog from '../../../../../components/SDialog/SDialog';
import Typography from '../../../../../components/Typography/Typography';
import useIsMobile from '../../../../../hooks/useIsMobile';

const OverviewTab = () => {
  const [loadData, setLoadData] = useState({});
  const { customerId } = useParams();
  const isMobile = useIsMobile();

  const { currentPartner, organisation } = useSelector((state) => ({
    currentPartner: selectCurrentPartner(state),
    organisation: selectOrganisation(state),
  }));

  const url = `/infrastructureManagement/v1/organisations/${customerId}/overview`;
  const history = useHistory();
  //redux
  const dispatch = useDispatch();

  const [showModal, setShowModal] = useState(false);
  const [showEditCustomerModal, setEditCustomerModal] = useState(false);
  const [showCustomerModal, setShowCustomerModal] = useState(false);
  const [showHandOverModal, setShowHandOverModal] = useState(false);
  const [showNewAdimModal, setShowNewAdminModal] = useState(false);
  const [showHandoverSuccess, setShowHandoverSuccess] = useState(false);
  const [showNewAdminSuccess, setShowNewAdminSuccess] = useState(false);
  const [customerAdmin, setcustomerAdmin] = useState({});

  useEffect(() => {
    if (organisation) {
      const { generalSetting } = organisation;
      const { admins: adm } = generalSetting;
      const index = adm?.findIndex((admins) => admins?.adminType === 2);

      if (index !== -1 && adm && adm[index]) {
        // Set the 'admin' for the first matching element
        setcustomerAdmin(adm[index]);
      } else {
        // Handle the case where there is no matching element or 'adm' is undefined
        setcustomerAdmin({});
      }
    }
  }, [organisation]);

  useEffect(() => {
    const getData = async () => {
      const res = await axiosInfraInstance({ method: 'GET', url: url });
      setLoadData(res.data.message);
    };
    getData();
  }, [url]);

  function displayEditCustomerModal() {
    setEditCustomerModal(true);
  }

  function displayModal() {
    if (customerAdmin?.adminType !== 2) {
      setShowNewAdminModal(true);
    } else {
      setShowHandOverModal(true);
    }
  }

  const handleDeleteOrganisation = () => {
    dispatch(
      doDeleteOrganisation(
        { partnerId: currentPartner.partnerId, organisationId: customerId },
        (status) => {
          if (status === 'success') {
            history.goBack();
          }
        },
      ),
    );
    setShowModal(false);
  };

  const handleNewAdmin = (data) => {
    const payload = { admins: [data] };

    dispatch(
      doUpdateOrganisation(
        {
          partnerId: currentPartner.partnerId,
          organisationId: customerId,
          payload,
          setLoading: false,
          isIndividual: true,
        },
        (status) => {
          if (status === 'success') {
            setShowNewAdminSuccess(true);
          }
        },
      ),
    );
  };
  const handleHandOverPopUp = () => {
    dispatch(
      doPartnerHandover(
        { organisationId: customerId, payload: {}, partnerId: currentPartner.partnerId },
        (status) => {
          if (status === 'success') {
            setShowHandoverSuccess(true);
          }
        },
      ),
    );
  };

  return (
    <Fragment>
      <div className={styles['container']}>
        <FlexRow alignItems='start'>
          <FlexRow justifyContent='start' className={styles['cards-container']}>
            <OverviewStatCard
              name="Total Access Points"
              stat={loadData.NoOfAccessPoints}
              icon={<Door style={{ width: '3.7rem', height: '3.7rem' }} />}
            />
            <OverviewStatCard
              name="No. of Detached Devices"
              stat={loadData.NoOfDetachedDevices}
              icon={<TotalRepeaters style={{ width: '3.7rem', height: '3.7rem' }} />}
            />
            <OverviewStatCard
              name="Total no. of Devices"
              stat={loadData.NoOfDevices}
              icon={<Devices style={{ width: '3.7rem', height: '3.7rem' }} />}
            />
            <OverviewStatCard
              name="Total no. of Gatways"
              stat={loadData.NoOfGateways}
              icon={<Device style={{ width: '3.7rem', height: '3.7rem' }} />}
            />
            <OverviewStatCard
              name="Total no. of Mesh IOs"
              stat={loadData.NoOfMeshIOs}
              icon={<TotalAccessPoint style={{ width: '3.7rem', height: '3.7rem' }} />}
            />
            <OverviewStatCard
              name="Total No. of Sites "
              stat={loadData.NoOfSites}
              icon={<TotalSites style={{ width: '3.7rem', height: '3.7rem' }} />}
            />
          </FlexRow>
          <FlexColumn className={styles['overview-container']}>
            <OverviewCard
              displayDeleteModal={() => setShowModal(true)}
              displayEditCustomerModal={displayEditCustomerModal}
              displayPartnerHandoverModal={displayModal}
            />
          </FlexColumn>
        </FlexRow>
      </div>
      {showModal && (
        <SDialog
          title='Delete Customer'
          open={showModal}
          onClose={() => {
            setShowModal(false);
          }}
          titleConfig={{
            variant: isMobile ? 'h6M' : 'h5M'
          }}
          secondaryButtonConfig={{
            text: 'Cancel',
            onClick: () => {
              setShowModal(false);
            }
          }}
          primaryButtonConfig={{
            text: 'Delete',
            color: 'error',
            onClick: () => handleDeleteOrganisation()
          }}
        >
          <Typography variant={isMobile ? "b2M" : "b1M"} style={{ padding: '1.5rem 0' }}> Are you sure you want to delete {organisation?.generalSetting ? organisation?.generalSetting?.name : ''} ? This action is non
            reversible and will cause you to lose all data associated with this customer/ s</Typography>
        </SDialog>
      )}

      {showCustomerModal && (
        <SDialog
          title='Customer Added'
          open={showCustomerModal}
          onClose={() => {
            setShowCustomerModal(false);
          }}
          titleConfig={{
            variant: isMobile ? 'h6M' : 'h5M'
          }}
          primaryButtonConfig={{
            text: 'Done',
            onClick: () => {
              setShowCustomerModal(false);
            },
            fullWidth: false
          }}
          actionsContainer={{
            justifyContent: 'end'
          }}
        >
          <Typography variant={isMobile ? "b2M" : "b1M"} style={{ padding: '1.5rem 0' }}>We successfully added the customer “New Customer”</Typography>
        </SDialog>
      )}


      {showHandoverSuccess && (
        <SDialog
          title='Handover Successful'
          open={showHandoverSuccess}
          onClose={() => {
            setShowHandoverSuccess(false);
          }}
          titleConfig={{
            variant: isMobile ? 'h6M' : 'h5M'
          }}
          primaryButtonConfig={{
            text: 'Done',
            onClick: () => {
              setShowHandoverSuccess(false);
            },
            fullWidth: false
          }}
          actionsContainer={{
            justifyContent: 'end'
          }}
        >
          <Typography variant={isMobile ? "b2M" : "b1M"} style={{ padding: '1.5rem 0' }}>Partner organisation successfully handed over to customer super admin</Typography>
        </SDialog>
      )}

      {showNewAdminSuccess && (
        <SDialog
          title='Successful'
          open={showNewAdminSuccess}
          onClose={() => {
            setShowNewAdminSuccess(false);
          }}
          titleConfig={{
            variant: isMobile ? 'h6M' : 'h5M'
          }}
          primaryButtonConfig={{
            text: 'Done',
            onClick: () => {
              setShowNewAdminSuccess(false);
            },
            fullWidth: false
          }}
          actionsContainer={{
            justifyContent: 'end'
          }}
        >
          <Typography variant={isMobile ? "b2M" : "b1M"} style={{ padding: '1.5rem 0' }}>Successfully added user. Please initiate partner handover after customer super admin signs up</Typography>
        </SDialog>
      )}

      {showEditCustomerModal && (
        <CustomerEditModal
          showModal={showEditCustomerModal}
          closeModal={() => setEditCustomerModal(false)}
        />
      )}
      {showHandOverModal && (
        <HandOverPopup
          showModal={showHandOverModal}
          closeModal={() => setShowHandOverModal(false)}
          onClick={handleHandOverPopUp}
          adminData={customerAdmin}
          handleUpdateAdmin={handleNewAdmin}
        />
      )}
      {showNewAdimModal && (
        <NewAdminPopup
          showModal={showNewAdimModal}
          closeModal={() => setShowNewAdminModal(false)}
          onClick={handleNewAdmin}
        />
      )}
    </Fragment>
  );
};
export default OverviewTab;
